export default __webpack_public_path__ + "images/7M.784cef2.png";